import { FunctionComponent } from 'react';

const HiddenInput: FunctionComponent<React.PropsWithChildren<DynamicForm.HiddenProps>> = ({ props }) => {
	return (
		<input { ...props } />
	);
};

export default HiddenInput;
